import { createContext, useContext, type ReactNode } from 'react';
import { DEFAULT_LOCALE, type Locale } from './locale';

const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export interface LocaleProviderProps {
  locale: Locale;
  children: ReactNode;
}

/** Makes the active locale available to any component below it via `useLocale()`. */
export function LocaleProvider({ locale, children }: LocaleProviderProps) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

/** Falls back to `DEFAULT_LOCALE` outside a provider, so components stay usable in isolation (Storybook-less demos, unit tests). */
export function useLocale(): Locale {
  return useContext(LocaleContext);
}
